import { useState, useRef, useEffect } from 'react'
import { SpeakerXMarkIcon, SpeakerWaveIcon } from '@heroicons/react/20/solid'
import { useAudioStore } from './useAudioStore'

const VolumeControl = () => {
  const { setAudioVolume, audioRef, cleanupAudio } = useAudioStore((state) => ({
    setAudioVolume: state.setAudioVolume,
    audioRef: state.audioRef,
    cleanupAudio: state.cleanupAudio,
  }))
  const [isMuted, setIsMuted] = useState(false)
  const [showSlider, setShowSlider] = useState(false)
  const volumeSliderRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    return () => {
      cleanupAudio()
    }
  }, [])

  const toggleMute = () => {
    if (!audioRef) return
    let newVolume = isMuted ? 1 : 0
    setAudioVolume(newVolume)
    setIsMuted(!isMuted)
  }

  const handleVolumeChange = (e) => {
    const newVolume = Number(e.target.value)
    setAudioVolume(newVolume)
    setIsMuted(newVolume === 0)
  }

  return (
    <div className="flex items-center justify-center gap-2">
      <button onClick={toggleMute}>
        {isMuted ? (
          <SpeakerXMarkIcon className="h-4 w-4 text-slate-600" />
        ) : (
          <SpeakerWaveIcon className="h-4 w-4 text-slate-600" />
        )}
      </button>
      <div ref={volumeSliderRef} className="flex h-1.5 w-16">
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          defaultValue="1"
          onChange={handleVolumeChange}
          className="h-full w-full cursor-pointer appearance-none rounded border bg-slate-200 focus:outline-none active:bg-slate-300"
        />
      </div>
    </div>
  )
}

export default VolumeControl
